/* (ASYNC) */
export const RESET_MODAL = 'RESET_MODAL';
export const RESET_ACCOUNT_WORKING_SHIFT_GROUP = 'RESET_ACCOUNT_WORKING_SHIFT_GROUP';

export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_INIT = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_INIT';
export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS';
export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE';

export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_INIT = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_INIT';
export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_SUCCESS = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_SUCCESS';
export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_FAILURE = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_COUNT_FAILURE';

export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_INIT = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_INIT';
export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_SUCCESS = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_SUCCESS';
export const FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_FAILURE = 'FETCH_ACCOUNT_WORKING_SHIFT_GROUP_NO_LOADING_FAILURE';

export const CREATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT = 'CREATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT';
export const CREATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS = 'CREATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS';
export const CREATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE = 'CREATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE';

export const UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT = 'UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_INIT';
export const UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS = 'UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS';
export const UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE = 'UPDATE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE';

export const DELETE_ACCOUNT_WORKING_SHIFT_GROUP_INIT = 'DELETE_ACCOUNT_WORKING_SHIFT_GROUP_INIT';
export const DELETE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS = 'DELETE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS';
export const DELETE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE = 'DELETE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE';

export const ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_INIT = 'ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_INIT';
export const ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS = 'ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_SUCCESS';
export const ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE = 'ACTIVE_ACCOUNT_WORKING_SHIFT_GROUP_FAILURE';


// WEBPACK FOOTER //
// ./source/client/actions/account_working_shift_group/types.js